import * as TYPES from './ar-invitation-actiontypes';

export const setAuthRepInvitation = (arInvitation) => ({
  type: TYPES.SET_AUTHORIZED_REP_INVITATION,
  arInvitation,
});

export const setArInvitationExists = (arInvitationExists) => ({
  type: TYPES.SET_AR_INVITATION_EXISTS,
  arInvitationExists,
});


export const setPrevInvitationRoute = (prevRoute) => ({
  type: TYPES.SET_PREV_ROUTE_BEFORE_INVITE,
  prevRoute,
});
